'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
require('./style-222d2b0f.js');
require('./typography/span.js');
require('./buttons-color-d198c1b7.js');
require('./button/button-icon.js');
var index$3 = require('./button/index.js');
var gradient = require('./button/gradient.js');
var badge = require('./badge.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  background: #f9f9f9;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  justify-content: space-between;\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  background: #f9f9f9;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  justify-content: space-between;\n  &:hover {\n    background-color: ", ";\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: 600;\n  font-size: ", "px;\n"], ["\n  font-family: Source Sans Pro, sans-serif;\n  font-weight: 600;\n  font-size: ", "px;\n"]);

var Header = styled__default.div(_templateObject, settings.COLOR.veryLightGray);

var TitleSection = styled__default.div(_templateObject2);

var Title = styled__default.div(_templateObject3, function (props) {
  return props.fontSize || 16;
});

var BUTTON_TYPE = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  GHOST: "ghost"
};

var mapActionButton = function mapActionButton(type) {
  switch (type) {
    case BUTTON_TYPE.PRIMARY:
      return gradient.BlueGradientButton;
    case BUTTON_TYPE.SECONDARY:
      return gradient.YellowGradientButton;
    case BUTTON_TYPE.GHOST:
      return index$3;
    default:
      return null;
  }
};

var Section = function Section(_ref) {
  var title = _ref.title,
      badge = _ref.badge,
      children = _ref.children,
      _ref$initialToggle = _ref.initialToggle,
      initialToggle = _ref$initialToggle === undefined ? false : _ref$initialToggle,
      actionButtonType = _ref.actionButtonType,
      _ref$actionButtonText = _ref.actionButtonText,
      actionButtonText = _ref$actionButtonText === undefined ? "Button" : _ref$actionButtonText,
      _ref$softToggle = _ref.softToggle,
      softToggle = _ref$softToggle === undefined ? false : _ref$softToggle,
      fontSize = _ref.fontSize,
      _ref$onClickActionBut = _ref.onClickActionButton,
      onClickActionButton = _ref$onClickActionBut === undefined ? function () {} : _ref$onClickActionBut;

  var _useState = React.useState(initialToggle),
      _useState2 = _babelHelpers.slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];

  var onClickToggle = function onClickToggle() {
    return setToggle(!toggle);
  };

  var ActionButton = React__default.useMemo(function () {
    return mapActionButton(actionButtonType);
  }, [actionButtonType]);

  var handleClickActionButton = React__default.useCallback(function (e) {
    e.stopPropagation();
    onClickActionButton(e);
  }, [onClickActionButton]);

  return React__default.createElement(
    React__default.Fragment,
    null,
    React__default.createElement(
      Header,
      { onClick: onClickToggle },
      React__default.createElement(
        TitleSection,
        null,
        React__default.createElement(
          Title,
          { fontSize: fontSize },
          title
        ),
        badge && badge
      ),
      React__default.createElement(
        TitleSection,
        null,
        ActionButton && React__default.createElement(
          ActionButton,
          {
            id: "section-action-button-" + actionButtonText,
            google: true,
            small: true,
            fontSize: "14px",
            lineHeight: "20px",
            height: "24px",
            margin: "0 20px 0 0",
            padding: "0 15px",
            onClick: handleClickActionButton },
          actionButtonText
        ),
        React__default.createElement(icon.Icon, {
          name: "chevron-down",
          className: toggle ? "flip" : "",
          size: "sm"
        })
      )
    ),
    softToggle ? React__default.createElement(
      "div",
      { hidden: !toggle },
      " ",
      children,
      " "
    ) : toggle && children
  );
};

Section.propTypes = {
  /** This is header of each section */
  title: PropTypes$1.string.isRequired,
  /** Badge will display after title */
  badge: PropTypes$1.instanceOf(badge.default),
  /** Content will display when show more details */
  children: PropTypes$1.element,
  /** Initial state of toggle */
  initialToggle: PropTypes$1.bool,
  /** Type to display an action button with a preferred style */
  actionButtonType: PropTypes$1.oneOf([BUTTON_TYPE.PRIMARY, BUTTON_TYPE.GHOST]),
  /** Text of the action button */
  actionButtonText: PropTypes$1.string,
  /** Function to handle an action button clicking */
  onClickActionButton: PropTypes$1.func,
  /** Flag to handle whether or not to hide the chid's visibility or to just not render it */
  softToggle: PropTypes$1.bool,
  /** The font size of the title */
  fontSize: PropTypes$1.number
};
Section.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Section",
  "props": {
    "initialToggle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Initial state of toggle"
    },
    "actionButtonText": {
      "defaultValue": {
        "value": "\"Button\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Text of the action button"
    },
    "softToggle": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Flag to handle whether or not to hide the chid's visibility or to just not render it"
    },
    "onClickActionButton": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to handle an action button clicking"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "This is header of each section"
    },
    "badge": {
      "type": {
        "name": "instanceOf",
        "value": "Badge"
      },
      "required": false,
      "description": "Badge will display after title"
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": "Content will display when show more details"
    },
    "actionButtonType": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "BUTTON_TYPE.PRIMARY",
          "computed": true
        }, {
          "value": "BUTTON_TYPE.GHOST",
          "computed": true
        }]
      },
      "required": false,
      "description": "Type to display an action button with a preferred style"
    },
    "fontSize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The font size of the title"
    }
  }
};

exports.Section = Section;
exports.default = Section;
exports.mapActionButton = mapActionButton;
//# sourceMappingURL=section.js.map
